module.exports = __webpack_public_path__ + "static/advanced-coating-fe05b95f936c47ec7e3ad8f6677db341.mp4";